<template>
    <div class="funcionalities-bg md:flex flex-col items-center py-5">
        <h2 class="funcionalities-bg dark-blue-funcionality text-bigger-size font-semibold mb-3 md:mb-8 px-5">
            Funcionalidades
        </h2>
        <div class="funcionalities-items md:grid md:grid-cols-12 px-section w-full animated ani-bottom-to-top-items opacity-1">
            <slot name="colItems" />
        </div>
    </div>
</template>

<style lang="postcss" scoped>
:deep() {
    .px-section {
        @apply md:px-20 xl:px-40 2xl:px-80;
    }

    .funcionalities-items {
        & > * {
            @apply flex md:gap-4 justify-start md:flex-col items-center;
            & > svg {
                width: 20%;
                max-width: 80px;

                @apply pl-5 md:pl-0 mr-5 my-4 md:m-0;
            }

            & > div {
                @media (min-width: 769px) {
                    max-width: 200px;
                }
                @apply md:text-center;
            }
        }

        & > :nth-child(odd) {
            @media (max-width: 767px) {
                background-color: #E2F1FA;
            }
        }
    }
}
</style>
